<template>
  <div class="wh-100">
    <nk-table
      id="table"
      class="table-border"
      :data="tableData"
      :noDataTitle="'该时间段暂无数据'"
      :columns="columns"
      :border="true"
      :rowselect="true"
      :arraySpanMethod="objectSpanMethod"
    >
    </nk-table>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
export default {
  components: { NkTable },
  data() {
    return {
      tableData: [],
      columns: [],
    };
  },
  methods: {
    init(config, table) {
      let columns = [];
      let tableData = [];
      for (let i = 0; i < table.length; i++) {
        const tr = table[i];
        if (i === 0) {
          for (let j = 0; j < tr.length; j++) {
            const td = tr[j];
            columns.push({
              prop: "column" + "_" + j,
              label: td,
              align: "center",
              show: true,
              width: "100",
            });
          }
        } else {
          let row = {};
          for (let j = 0; j < tr.length; j++) {
            let td = "-";
            if (j) {
              td = isFinite(+tr[j]) ? (+tr[j]).toFixed(2) : tr[j] ?? "-";
            } else {
              td = tr[j];
            }
            row["column" + "_" + j] = td;
          }
          row["rowspan"] = 0;
          row["colspan"] = 0;
          tableData.push(row);
        }
      }
      this.columns = columns;
      const prop = columns[0].prop;

      let map = new Map();
      for (let i = 0; i < tableData.length; i++) {
        const name = tableData[i][prop];
        if (map.get(name)) {
          map.set(name, map.get(name) + 1);
        } else {
          map.set(name, 1);
        }
      }

      for (let i = 0; i < tableData.length; i++) {
        const name = tableData[i][prop];
        if (map.get(name) > 0) {
          tableData[i]["rowspan"] = map.get(name);
          tableData[i]["colspan"] = 1;
          map.set(name, 0);
        }
      }
      this.tableData = tableData;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wh-100 {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.table-border {
  .el-table td,
  .theme-defalt .table-warp .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
</style>
